export type Visibility = 'OPEN' | 'PRIVATE' | 'SHARED';

export const computeVisibility = (
  userIds: number[],
  departmentIds: number[],
  currentUserId: number,
): Visibility => {
  if (userIds.length === 0 && departmentIds.length === 0) {
    return 'OPEN';
  }
  if (
    userIds.length === 1 &&
    userIds.includes(currentUserId) &&
    departmentIds.length === 0
  ) {
    return 'PRIVATE';
  }
  return 'SHARED';
};
